module.exports = __webpack_public_path__ + "37cf16fbcbbadcfb3a9b3d603fa616c0.png";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/play-arrow.png
// module id = 499
// module chunks = 0